import { getObjectFromHash } from '@/legacy-src/utilities/codingPublicHash'

import { CartParamsSchema } from '@/src/domains/cart/schema'

export const parseCartParams = (paramsString: string) => {
  try {
    return CartParamsSchema.parse(getObjectFromHash(paramsString))
  } catch {
    return CartParamsSchema.parse({})
  }
}
